// Phase T2.0A Prompt 2.2 — Member-facing Alternate list display.
//
// Shows the FIFO waitlist below the main roster. Alternate #1, #2, … order.
// The viewer's own row is highlighted so members quickly find their spot.
// If the list is empty, this component returns null so full events without
// alternates don't render an empty card.

import React from 'react';
import MemberLink from '../MemberLink';

export default function AlternateList({ alternates = [], viewerProfileId = null }) {
  if (!alternates || alternates.length === 0) return null;
  return (
    <div className="border border-[#e3dcd1] rounded-2xl bg-white p-4 sm:p-5" data-testid="alternate-list">
      <div className="flex items-baseline justify-between gap-2 mb-3">
        <div className="text-[11px] uppercase tracking-wider text-[#6a766e]">
          Alternate List <span className="text-[#9aa39d]">· {alternates.length}</span>
        </div>
        <div className="text-[11.5px] text-[#6a766e]">FIFO — first in, first up</div>
      </div>
      <ul className="space-y-1.5">
        {alternates.map((a) => {
          const isMe = viewerProfileId && a.profile_id === viewerProfileId;
          return (
            <li
              key={a.id}
              data-testid={`alternate-row-${a.profile_id}`}
              className={`flex items-center gap-3 rounded-xl border px-3 py-2 ${
                isMe
                  ? 'bg-amber-50 border-amber-200'
                  : 'bg-[#fbfaf8] border-[#f3f1ec]'
              }`}
            >
              <div className="shrink-0 w-7 h-7 rounded-full bg-white border border-[#e3dcd1] flex items-center justify-center text-[11px] font-semibold text-[#013523]">
                #{a.position}
              </div>
              <div className="min-w-0 text-[14px] text-[#013523] font-medium truncate">
                <MemberLink profileId={a.profile_id} name={a.profile?.name} />
                {isMe && <span className="ml-2 text-[10px] uppercase tracking-wider text-amber-800">You</span>}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
